import React from "react";
import Footer from "../../../websiteComponents/footer";

const LoginFooter = () => {
    return (
        <div >
            <Footer />
        </div>
    )
}

export default LoginFooter;